import React from 'react'

const TransactionStatusSchema = ({ status }) => {
    let backgroundColor;
    let color;
    let uValue = status.toUpperCase();
    if (uValue === "FAILED" || uValue === "REJECTED" || uValue === "TIMEOUT") {
        backgroundColor = "#FDE3D6";
        color = "#B9232F";
    } else if (
        uValue === "PENDING" ||
        uValue === "INITIATED" ||
        uValue === "REFUND PENDING REVIEW" ||
        uValue === "PENDING REVIEW" ||
        uValue === "AWAITING SPLIT INSTRUCTIONS" ||
        uValue === "REQUIRESACTION" ||
        uValue === "REDIRECTION" ||
        uValue === "POSTED" ||
        uValue === "CANCELLED"
    ) {
        backgroundColor = "#FBEFCB";
        color = "#9E5707";
    } else if (
        uValue === "APPROVED" ||
        uValue === "SETTLED" ||
        uValue === "COMPLETED" ||
        uValue === "RECEIVED"
    ) {
        backgroundColor = "#D5FBD2";
        color = "#0B6A48";
    } else if (uValue === 'EXPIRED') {
        backgroundColor = "#D9D9D9";
        color = "#595959";
    }
    return (
        <span
            style={{
                marginLeft: "-20px",
                paddingBottom: "6px",
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "5px",
                borderRadius: "8px",
                backgroundColor,
                color,
                textTransform: "uppercase",
            }}
        >
            {status}
        </span>
    );
}

export default TransactionStatusSchema
